import {
    friendRequestsQueryOptions,
    sentFriendRequestsQueryOptions
} from '@/api/queries/friendship';
import { useQuery } from '@tanstack/react-query';

/**
 * Hook to fetch incoming friend requests using TanStack Query
 * Uses domain-oriented query options
 */
export function useFriendRequests() {
  return useQuery(friendRequestsQueryOptions());
}

/**
 * Hook to fetch sent friend requests using TanStack Query
 * Uses domain-oriented query options
 */
export function useSentFriendRequests() {
  return useQuery(sentFriendRequestsQueryOptions());
}
